import React from 'react';
import classnames from 'classnames';
import styles from './PanelButtons.scss';
const PanelButtons = ({ className = '', isInPanel = false, children = null, }) => (<div className={classnames('panel-buttons-wrapper', className, isInPanel ? styles.wrapperPanel : styles.wrapper)}>
    {children}
  </div>);
export default PanelButtons;
